import model from "@/api/index";

const app = {
  state: {
    navActive: "home",
    currentContact: {},
    hospitalInfo: {}
  },
  mutations: {
    SET_NAVACTIVE: (state, name) => {
      state.navActive = name;
    },
    SET_CURRENTCONTACT: (state, data) => {
      state.currentContact = data;
    },
    SET_HOSPITALINFO: (state, info) => {
      state.hospitalInfo = info;
    }
  },
  actions: {
    setNavActive({ commit }, name) {
      commit("SET_NAVACTIVE", name);
    },
    setCurrentContact({ commit }, data) {
      commit("SET_CURRENTCONTACT", data);
    },
    getHospitalInfo({ commit }) {
      // const hospitalInfo = this.state.app.hospitalInfo;
      // if (!(hospitalInfo && hospitalInfo.Id)) {
      model
        .$post("Hospital_Info", {
          Id: 1
        })
        .then(res => {
          commit("SET_HOSPITALINFO", res.data);
        })
        .catch(err => {
          console.log(err);
        });
      // }
    }
  }
};

export default app;
